export default __webpack_public_path__ + "static/media/app-dev.5614a23e.png";